import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {AuthService} from '@app/core/services/auth.service';
import {BaseService} from '@app/core/services/base.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {Observable} from 'rxjs';
import {PaginationHolder} from '@app/core/models/pagination.model';
import {ShiftDraft} from '@app/core/models/ShiftDraft.model';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {map} from 'rxjs/operators';

@Injectable()
export class ShiftDraftService extends BaseService {
	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		public httpService: HttpService,
		public store: Store<IAppState>,
	) {
		super(authService, interService, httpService, store);
	}

	public getShiftDrafts(page: number, page_size: number, search_query: string): Observable<ShiftDraft[]> {
		return this.httpService.getJson('shiftDrafts', {page, page_size, search_query}).pipe(
			map((res: PaginationHolder<ShiftDraft>) => res.data)
		);
	}

	public createShiftDraft(shiftDraft: ShiftDraft): Observable<ShiftDraft> {
		return this.httpService.postJson<ShiftDraft>('shiftDrafts', shiftDraft);
	}

	public releaseShiftDraft(shiftDraft: ShiftDraft): Observable<ShiftDraft> {
		shiftDraft.released = true;

		return this.updateShiftDraft(shiftDraft);
	}

	public updateShiftDraft(shiftDraft: ShiftDraft): Observable<ShiftDraft> {
		return this.httpService.patchJson<ShiftDraft>('shiftDrafts/' + shiftDraft.id, shiftDraft);
	}

	public deleteShiftDraft(shiftDraft: ShiftDraft): Observable<unknown> {
		return this.httpService.deleteJson('shiftDrafts/' + shiftDraft.id);
	}

	public ngOnDestroy(): void {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}
}
